// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
let isLocalhost = window.location.hostname.startsWith('localhost');

export const environment = {
  production: isLocalhost ? true : false,
  defaultauth: 'logan',
  loganConfig: {
    key: '4b9301bdb46dd6336a9af3e00dd5553c24994d93',
    url: isLocalhost
    ? 'http://localhost:8081'
    : 'https://api-logan.satrastreamento.dev.br', //'https://api-logan.satrastreamento.dev.br',
    websocktprocessauto: isLocalhost
    ? 'ws://localhost:8081/ws'
    : 'wss://api-logan.satrastreamento.br:8081/ws',
  },
  keyCrypto: 'QWPvmQPWtjAsdSAgdnAsq',
  googleRecaptchaConfig: {
    key: '6LecLpwjAAAAAAoBnsAh1JZroXTDMhpDKp55Thuc',
  },
  googleMaps: {
    key: 'AIzaSyC1N5e3JUEWs8C3YBw-TGVLkvcj26Pgnw0',
  },
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
